import React, { Fragment, useEffect, useState } from 'react'

//* import service
import {  getFirebaseExams } from '../../services/examsService';

//* import SubComponent

import LatestApplyCard from '../../Components/LatestApplyCard/LatestApplyCard';
import notFound from "../../assets/images/icons/not-found.png";
import SearchBar from "../../SubComponent/SearchBar";

//* import MUI
import { Grid } from '@mui/material';

//* Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

//* Import store
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";


import cssClasses from "./Home.module.css";
import Button from '../../SubComponent/Button';
import { errorToast } from '../../services/Toast';

export default function Home() {

  const dispatch = useDispatch();

  const [examList, setExamList] = useState([]);

  const [searchExams , setSearchExams] = useState([]);
  const [serverMetaDataList, setServerMetaDataList] = useState([])
  const [studentSearchValue, setStudentSearchValue] = useState("");
  const [searchField, setSearchField] = useState("examNameForSearch");


  useEffect(() => {
    dispatch(actions.activeMenu('home'));
    getDataFromServer(searchField, null, studentSearchValue === "" ? undefined : studentSearchValue, false);
  }, [studentSearchValue, searchField])

  function getDataFromServer(_searchField, _lastDoc, _studentSearchValue, _merge) {
    getFirebaseExams(searchField, _lastDoc, _studentSearchValue).then(res => {
      let _studentList = res.docs.map(m => ({ docID: m.id, ...m.data() }));
      console.log(_studentList);
      if (_merge) {
        setServerMetaDataList(pre => [...pre, ...res.docs])
        setExamList(pre => [...pre, ..._studentList]);
      } else {
        setServerMetaDataList(res.docs);
        setExamList(_studentList);
      }
    }).catch(err => {
      console.log(err);
      errorToast(err.toString());
      if (_merge) {
        setServerMetaDataList(pre => [...pre])
        setExamList(pre => [...pre]);
      } else {
        setServerMetaDataList([]);
        setExamList([]);
      }
    })
  }


  async function loadMore(){
    getDataFromServer(searchField, serverMetaDataList[serverMetaDataList.length - 1], studentSearchValue === "" ? undefined : studentSearchValue, true);
  }

  return (
    <>

      <div className={cssClasses.latestApply}>
        <p className={cssClasses.title}>All Exams</p>
        <div style={{width:"250px" , marginLeft:"auto" , paddingBottom:"2rem" , marginRight:"5rem"}}>
          <SearchBar
            placeholder={"Search Exam"}
            search={(_value) => {setStudentSearchValue(_value)}}
          />
        </div>
        <Grid container >
          { searchExams &&  examList.map((examObject,index) => (
              <Fragment key={`LatestApplyCard_${examObject.name}_LatestApplyCard_${index+1}`}>
                  <Grid item  key={index} >
                    <LatestApplyCard examObject={examObject} />
                  </Grid>
              </Fragment> 
            ))
          } 
          </Grid>
          {examList.length === 0 &&
            <div className={cssClasses.ResultsDiv }>
              <img src={notFound} alt={""}  width="40px" height="40px" style={{alignSelf:"center"}}/>
              <p className={cssClasses.title} style={{alignSelf:"center"}}>no results found!</p>
            </div>
          }
          { serverMetaDataList.length % 12 === 0 &&
            <div className={cssClasses.ButtonWrapper}>
              <Button
                style={{ color: '#6941C6', backgroundColor: '#ffffff' }}
                btnName={'View More'}
                clicked={() => loadMore()}
              />
            </div> 
           }      
      </div>

    </>
  )
}
